<template>
  <div class="modal__cover">
    <div class="modal__content">
      <div class="modal__descriptions">
        <div class="modal__text">
          <div class="modal__text__title">
            <span>{{ revisionedContentTitle }}<br />一部改定のお知らせ</span>
          </div>
          <div class="modal__text__caption">
            <p>
              {{ revisionedDate }}に<br />
              {{ revisionedContentTitle }}を<br />
              一部改定いたしました。
            </p>
            <p>
              gifteeを引き続きご利用いただくために<br />
              改めて同意をいただく必要があります。
            </p>
            <p>
              <a :href="revisionedContentUrl">{{ revisionedContentTitle }}</a>
            </p>
            <p>
              <a href="/contact/top">お問い合わせ</a>
            </p>
          </div>
        </div>
        <div class="modal__btn">
          <div class="modal__btn--primary">
            <button
              type="button"
              class="btn btn--primary"
              style="margin: 0;"
              :disabled="!isSubmittable"
              @click="onClickPrimaryButton"
            >
              同意する
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    revisionedContentTitle: {
      type: String,
      required: true
    },
    revisionedContentUrl: {
      type: String,
      required: true
    },
    revisionedDate: {
      type: String,
      required: true
    },
    isSubmittable: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    onClickPrimaryButton() {
      this.$emit('clicked-primary')
    }
  }
}
</script>
<style lang="scss" scoped>
.modal {
  &__descriptions {
    padding: 32px 24px;
  }
  &__text {
    &__title {
      white-space: pre-wrap;
    }
    &__caption {
      p {
        color: $black;
      }

      p:not(:last-child) {
        margin-bottom: 16px;
      }
    }
  }
}
</style>
